import React from 'react'
import { FontAwesomeIcon }  from '@fortawesome/react-fontawesome'
import {  faDatabase, faLink } from '@fortawesome/free-solid-svg-icons'
//import LinkToPdf from '@components/ContentItem/LinkToPdf'

const ContentLink = ({ item }) => {

    // if(item.data.resource_type === "Document"){
    //   return <LinkToPdf contentItemPath={item.data.content_item_path}/>
       
    // }
     if (item.data.resource_type === "Database" && item.data.content_item_path != null){
      return (
        <p><a href={item.data.content_item_path}><FontAwesomeIcon icon={faDatabase}/> Explore the database</a></p>
      )
    }
    else if (item.data.resource_type === "Website" && item.data.content_item_path != null){
      return (
        <p><a href={item.data.content_item_path}><FontAwesomeIcon icon={faLink}/> Go to the website</a></p>
      )
    }
    else {
      return null
    }
  }

export default ContentLink;